import { PayloadAction } from '@reduxjs/toolkit';

import { Warning, WarningsState } from 'editor/src/store/editorModules/warnings/types';

const setWarningsReducer = (state: WarningsState, action: PayloadAction<Warning[]>) => {
  state.list = action.payload;
};

export default setWarningsReducer;
